import React from "react";
import "streamdown/styles.css";
import { Streamdown } from "streamdown";
import { code } from "@streamdown/code";
import { cn } from "../../utils/cn";

interface MarkdownContentProps {
  children: string;
  isStreaming?: boolean;
  className?: string;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({
  children,
  isStreaming = false,
  className,
}) => {
  "use memo";

  return (
    <Streamdown
      controls={{ table: false, mermaid: false }}
      isAnimating={isStreaming}
      plugins={{ code }}
      shikiTheme={["github-light", "github-dark"]}
      className={cn("l-streamdown text-primary", className)}
    >
      {children}
    </Streamdown>
  );
};

export { MarkdownContent, type MarkdownContentProps };
